export default "__VITE_ASSET__BoDIQ_kW__"